var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriefcaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 45,
    viewBox: "0 0 52 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M47.5983 35.4556H4.40167C1.97071 35.4556 0 33.4848 0 31.0541V4.40147C0 1.97051 1.97071 0 4.40167 0H17.4315L23.1636 3.95786H47.5983C50.0293 3.95786 51.9998 5.92857 51.9998 8.35953V31.0541C51.9998 33.4848 50.0293 35.4556 47.5983 35.4556Z",
    fill: "#8A73E1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M49.2072 41.1191H2.79341C1.75884 41.1191 0.919922 40.2805 0.919922 39.2458V8.23559C0.919922 7.20102 1.75884 6.3623 2.79341 6.3623H49.2072C50.2418 6.3623 51.0807 7.20102 51.0807 8.23559V39.2458C51.0807 40.2805 50.2418 41.1191 49.2072 41.1191Z",
    fill: "#FFEFE9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M48.902 40.4874L2.96304 40.4383C1.93906 40.4372 1.10961 39.6064 1.1107 38.5822L1.14353 7.88928C1.14462 6.86529 1.97584 6.03604 2.99983 6.03714L48.9388 6.08627C49.9628 6.08736 50.7922 6.91839 50.7912 7.94237L50.7583 38.6353C50.7572 39.6595 49.926 40.4885 48.902 40.4874Z",
    fill: "#FFEFE9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M47.5983 44.3145H4.40167C1.97071 44.3145 0 42.3438 0 39.913V12.6849C0 10.2539 1.97071 8.2832 4.40167 8.2832H47.5983C50.0293 8.2832 51.9998 10.2539 51.9998 12.6849V39.913C51.9998 42.3438 50.0293 44.3145 47.5983 44.3145Z",
    fill: "#6141AC"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M14.6758 32.874V35.9763C14.6758 37.7231 16.0918 39.1392 17.8384 39.1392H34.1606C35.9074 39.1392 37.3236 37.7231 37.3236 35.9763V32.874",
    stroke: "white",
    strokeWidth: 3.00688,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M23.2956 22.4466H20.1413C19.4291 22.4466 19.0053 21.6516 19.4022 21.0604L22.2365 16.839L24.4634 13.522C25.1973 12.4287 26.8054 12.4287 27.5393 13.522L29.7662 16.839L32.6003 21.0604C32.9974 21.6516 32.5736 22.4466 31.8614 22.4466H28.6999V29.8594H23.2956V22.4466Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M23.2929 30.8291H28.6973V32.915H23.2929V30.8291Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M23.2939 33.9465H28.6982V34.9336H23.2939V33.9465Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcaseIcon);
export default __webpack_public_path__ + "static/media/briefcase-icon.633bdf0f9539979acc5cb674ae9888a5.svg";
export { ForwardRef as ReactComponent };